<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-admin-manufacturerCreate"
    >
      <h2 class="o-heading o-heading--size-2 o-heading--border" slot="header">
        {{
          mutableObject.id === 0
            ? translationsModelsModal.createHeadline
            : `${translationsManufacturersTable.editModel} "${
                mutableObject.name
              }"`
        }}
      </h2>
      <div slot="body">
        <div
          class="c-admin-manufacturerCreate__inputs-wrap o-grid o-grid--gutter-normal o-grid--padding-none o-grid--align-items-center"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsModelsModal.modelName || "" }}
              </h4>
              <input
                class="o-input o-input--modal"
                type="text"
                maxlength="255"
                v-model="mutableObject.name"
                :placeholder="translationsCustom.addValue || ''"
              />
              <div class="o-label o-label--help-text">
                {{ translationsModelsModal.modelNameHelp || "" }}
              </div>
            </div>
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsModelsModal.modelSelectable || "" }}
              </h4>
              <div class="o-grid o-grid--gutter-tiny">
                <div class="o-grid__group">
                  <div
                    class="o-grid__item o-grid__item--12"
                    v-for="(option, name) in selectableOptions"
                    :key="option"
                  >
                    <input
                      type="radio"
                      class="o-radio"
                      v-model="mutableObject.isSelectable"
                      v-bind:value="option"
                      :id="`radio-${option}`"
                    />
                    <label :for="`radio-${option}`">{{
                      translationsCustom[name] || option
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="o-label o-label--help-text">
                {{ translationsModelsModal.modelSelectableHelp || "" }}
              </div>
            </div>
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsModelsModal.modelConnectedTo || "" }}
              </h4>
              <v-select
                label="name"
                :placeholder="translationsCustom.addValue || ''"
                v-model="mutableObject.manufacturerId"
                :options="sortedManufacturers"
                :reduce="option => option.id"
                :clearable="false"
                :filterable="true"
                :searchable="true"
              >
                <template slot="selected-option" slot-scope="option">
                  <span class="vs__dropdown-option__name">
                    {{ option.name }}
                  </span>
                  <span
                    class="vs__dropdown-option__type"
                    v-if="option.isSelectable"
                  >
                    {{ translationsCustom.selectableForEndUsers }}
                  </span>
                </template>
                <template slot="option" slot-scope="option">
                  <span class="vs__dropdown-option__name">
                    {{ option.name }}
                  </span>
                  <span
                    class="vs__dropdown-option__type"
                    v-if="option.isSelectable"
                  >
                    {{ translationsCustom.selectableForEndUsers }}
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="o-button"
                v-if="mutableObject.id === 0"
                :disabled="!canSubmit"
                @click="create"
              >
                {{ translationsManufacturersTable.addModel }}
              </button>
              <button
                class="o-button"
                v-else
                :disabled="!canSubmit"
                @click="edit"
              >
                {{ translationsManufacturersTable.editModel }}
              </button>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="o-button o-button--transparent"
                @click="closeModal()"
              >
                {{ translationsCustom.cancel || "" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      name: "Angiv status",
      showModal: false,
      mutableObject: {
        id: 0, // BE needs it to be 0 and not NULL
        isSelectable: false,
        manufacturerId: 0,
        name: ""
      }
    };
  },
  props: {
    model: { type: Object, required: false },
    showModelCreate: { type: Boolean, required: true }
  },
  computed: {
    ...mapState("manufacturers", ["selectableOptions", "all"]),
    ...mapGetters("manufacturers", [
      "availiableManufacturers",
      "notAvailableManufacturers"
    ]),
    ...mapState("translations", {
      translationsModelsModal: "modelModal",
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    }),
    sortedManufacturers() {
      const sortedManufacturers = this.availiableManufacturers.concat(
        this.notAvailableManufacturers
      );
      return sortedManufacturers;
    },
    canSubmit() {
      const canSubmit =
        this.mutableObject.name !== "" &&
        this.mutableObject.manufacturerId !== 0;
      return canSubmit;
    }
  },
  methods: {
    ...mapActions("manufacturers", ["addModel", "editModel"]),
    closeModal() {
      this.mutableObject = {
        id: 0, // BE needs it to be 0 and not NULL
        isSelectable: false,
        manufacturerId: 0,
        name: ""
      };
      this.showModal = false;
      this.$emit("close");
    },
    create() {
      this.addModel(this.mutableObject);
      this.closeModal();
    },
    edit() {
      this.editModel(this.mutableObject);
      this.closeModal();
    }
  },
  watch: {
    showManufacturerCreate(newValue) {
      this.showModal = newValue;
    }
  },
  created() {
    if (this.manufacturer) {
      this.mutableObject = this.model;
    }
    this.$nextTick(() => {
      this.showModal = this.showModelCreate;
    });
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if (mutation.type === "manufacturers/setEditModel") {
        if (mutation.payload.models) {
          // THIS IS CREATE MODEL
          this.mutableObject.manufacturerId = mutation.payload.id;
        } else {
          // THIS IS EDIT MODEL
          this.mutableObject = JSON.parse(JSON.stringify(mutation.payload));
        }
        this.showModal = true;
      }
    });
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-admin-manufacturerCreate {
  .v-select {
    .vs {
      &__dropdown-option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: toRem(5px 15px);
        &--highlight {
          background: $s-cp-sup-blue;
          .vs__dropdown-option__type {
            color: $s-cp-neutral-800;
          }
        }
        &__type {
          @include setStyles("12", $s-typography-sizes);
          color: $s-cp-neutral-400;
        }
        &__name {
          @include setStyles("14", $s-typography-sizes);
          padding-right: toRem(5px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
